var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var inputStyles = {
    root: function (_a) {
        var p = _a.props;
        return (__assign({ display: 'inline-flex', position: 'relative', alignItems: 'center', outline: 0 }, (p.fluid && { width: '100%' })));
    },
    input: function (_a) {
        var p = _a.props, v = _a.variables;
        return (__assign({ outline: 0, border: v.border, borderRadius: v.borderRadius, color: v.fontColor, backgroundColor: v.backgroundColor, position: 'relative', padding: v.inputPadding }, (p.fluid && { width: '100%' }), (p.inline && { float: 'left' }), { '::placeholder': {
                color: v.fontColor,
            }, ':focus': {
                borderBottomColor: v.inputFocusBorderBottomColor,
                boxShadow: v.boxShadow,
            } }, (p.clearable && { padding: v.inputPaddingWithIconAtEnd }), (p.icon && {
            padding: p.iconPosition === 'start' ? v.inputPaddingWithIconAtStart : v.inputPaddingWithIconAtEnd,
        })));
    },
    icon: function (_a) {
        var iconPosition = _a.props.iconPosition, v = _a.variables;
        return (__assign({ position: v.iconPosition, color: v.iconColor }, (iconPosition === 'start' && {
            left: v.iconLeft,
        }), (iconPosition === 'end' && {
            right: v.iconRight,
        }), { outline: 0 }));
    },
};
export default inputStyles;
